module.exports = __webpack_public_path__ + "static/img/cervicalPain_2.fb496213.png";